interface ScheduleFields {
  schedule_enabled: boolean;
  schedule_interval_days: number;
  schedule_time: string;
  last_run_at: string | null;
}

const SLACK_MS = 2 * 3_600_000;

/**
 * When the scheduler will next start a sync — mirrors the backend's isDue():
 * the first schedule_time after (last run + interval − 2h slack), and not in the past.
 */
export const nextRunAt = (c: ScheduleFields, now: Date = new Date()): Date | null => {
  if (!c.schedule_enabled) return null;
  const [hh, mm] = c.schedule_time.split(':').map(Number);
  if (Number.isNaN(hh) || Number.isNaN(mm)) return null;

  const earliest = c.last_run_at
    ? new Date(new Date(c.last_run_at).getTime() + c.schedule_interval_days * 86_400_000 - SLACK_MS)
    : now;
  const from = earliest > now ? earliest : now;
  const candidate = new Date(from);
  candidate.setHours(hh, mm, 0, 0);
  if (candidate < from) candidate.setDate(candidate.getDate() + 1);
  return candidate;
};
